// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';
import { isEqual } from 'lodash/fp';
export default {
  get MESSAGES() {
    return {
      M01: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_INCORECT_CREDENTIALS'),
      M02: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_RESET_PASSWORD_SUCCESSFULLY'),
      M04: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_PASSOWRD_EXPIRED'),
      M08: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_CONTACT_ADMIN'),
      M15: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_PASSWORD_LINK_EXPIRED'),
      M16: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_PASSWORD_EXPIRY')
    };
  },
  STEP_KEYS: {
    AccountInfo: 'AccountInfo',
    SecurityInfo: 'SecurityInfo',
    QuestionInfo: 'QuestionInfo',
    PasswordInfo: 'PasswordInfo'
  },
  get CONSTRAINTS() {
    return {
      tenantName: {
        // presence: {
        //   presence: true,
        //   message: 'Organization is required.'
        // }
      },
      userName: {
        presence: {
          presence: true,
          message: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_USERID_REQUIRED')
        }
      },
      firstName: {
        presence: {
          presence: true,
          message: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_FIRST_NAME_REQUIRED')
        }
      },
      lastName: {
        presence: {
          presence: true,
          message: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_LAST_NAME_REQUIRED')
        }
      },
      emailAddress: {
        format: {
          pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
          message(value, attribute, validatorOptions, attributes, globalOptions) {
            return localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_INVALID_EMAIL');
          }
        }
      },
      password: {
        presence: {
          presence: true,
          message: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_NEW_PASSWORD_REQUIRED')
        }
      },
      currentPassword: {
        presence: {
          presence: true,
          message: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_CURRENT_PASSWORD_REQUIRED')
        }
      },
      confirmPassword: {
        presence: {
          presence: true,
          message: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_NEW_PASSWORD_CONFIRM')
        },
        equality: {
          attribute: 'password',
          message: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_NEW_AND_CONFIRM_PASSOWRD_NOT_MATCHED'),
          comparator(firstOperand, secondOperand) {
            return isEqual(firstOperand, secondOperand);
          }
        }
      },
      question: {
        presence: {
          presence: true,
          message: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_SECURITY_QUESTION_IS_REQUIRED')
        }
      },
      answer: {
        presence: {
          presence: true,
          message: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_SECURITY_ANSWER_IS_REQUIRED')
        }
      },
      yourAnswer: {
        presence: {
          presence: true,
          message: localizer.getText('COMMON_LABEL_YOUR_ANSWER_IS_REQUIRED')
        }
      },
      loginPassword: {
        presence: {
          presence: true,
          message: localizer.getText('ACCOUNT_CONSTANTS_MESSAGE_PASSWORD_IS_REQUIRED')
        }
      }
    };
  },
  MODES: {
    PASSWORD_SETUP: 'PasswordSetup',
    RESET_PASSWORD: 'ResetPassword',
    FORGOT_PASSWORD: 'ForgotPassword'
  },
  HEADER_KEYS: {
    access_token: 'access_token',
    current_tenant: 'current_tenant',
    selected_tenant: 'selected_tenant',
    prefer: 'Prefer'
  },
  HEADER_PREFER: {
    minimal: 'return=minimal',
    representation: 'return=representation'
  },
  NOTIFICATION_KEYS: {
    PASSWORD_EXPIRY: 'PasswordExpiry'
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.AccountConstants.js